import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="number-filter"
export default class extends Controller {
  static targets = ['input', 'button', 'text'];
  static values = {
    caption: String,
    number: Number,
  };

  connect() {
    this.connected = true;
  }

  setNumber() {
    this.numberValue = this.inputTarget.value;
  }

  numberValueChanged(newValue, oldValue) {
    this.inputTarget.value = newValue ? newValue : '';
    this.buttonTarget.setAttribute('data-active', newValue ? 'true' : 'false');
    this.textTarget.innerText = this.buttonText();

    if (!this.connected) {
      return;
    }

    if (newValue != oldValue) {
      this.element.closest('form').requestSubmit();
      this.dispatch('changed');
    }
  }

  buttonText() {
    if (!this.numberValue) {
      return this.captionValue;
    } else {
      return `${this.captionValue} (${this.numberValue})`;
    }
  }

  reset() {
    this.numberValue = undefined;
  }
}
